
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ofertas",
      function () {
        return require("private-next-pages/ofertas/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ofertas"])
      });
    }
  